import React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  border: '1px solid #D6B981',
  backgroundColor: theme.palette.background.paper,
  '& .MuiDataGrid-row': {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.common.white,
    },
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.grey[200],
    },
  },
}));

const DatagridTable = ({
  columns = [],
  height = 600,
  rows = [],
  loading = false,
  paginationModel = { page: 0, pageSize: 10 },
  onPaginationModelChange,
  rowCount = 0,
  pageSizeOptions = [5, 10, 25],
  toolbarComponent = null,
  ...props
}) => {
  return (
    <Box sx={{ height, width: '100%' }}>
      <StyledDataGrid
        columns={columns}
        rows={rows}
        loading={loading}
        slots={{
          toolbar: () => toolbarComponent,
        }}
        pagination
        paginationMode="server"
        rowCount={rowCount}
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}
        pageSizeOptions={pageSizeOptions}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        showToolbar={!!toolbarComponent}
        initialState={{
          density: 'comfortable',
          pagination: {
            paginationModel: {
              pageSize: paginationModel?.pageSize || 10, 
            },
          },
        }}
        {...props}
      />
    </Box>
  );
};

export default DatagridTable;